<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <user-form />
  </v-container>
</template>

<script>
import UserForm from './_Form'

export default {
  name: 'AdminNotificationNew',
  components: {
    UserForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: 'お知らせ一覧', disabled: false, to: { name: 'AdminNotifications' }, exact: true },
        { text: 'お知らせー追加', disabled: true, to: '' },
      ],

    }
  },
  created() {
  },
  methods: {}
}
</script>
